"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
const white = '#FFFFFF';
const black = '#000000';
var _default = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#020013',
    brown: '#883907',
    brownOpaque: 'rgba(136, 57, 7, 0.5)',
    main: '#0a2a38',
    light: '#375262'
  },
  secondary: {
    contrastText: black,
    dark: '#649000',
    main: '#96c12c',
    light: '#caf561'
  },
  success: {
    contrastText: white,
    dark: _core.colors.green[900],
    main: _core.colors.green[600],
    light: _core.colors.green[400]
  },
  info: {
    contrastText: white,
    dark: _core.colors.blue[900],
    main: _core.colors.blue[600],
    light: _core.colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: _core.colors.orange[900],
    main: _core.colors.orange[600],
    light: _core.colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: _core.colors.red[900],
    main: '#b00020',
    light: _core.colors.red[400]
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
    link: _core.colors.blue[600]
  },
  background: {
    "default": '#f1f3f3',
    paper: white
  },
  icon: _core.colors.blueGrey[600],
  divider: 'rgba(0, 0, 0, 0.12)',
  dashboard: {
    night: '#283d5a',
    ocean: '#2367cf',
    sky: '#2da1ff',
    sunrise: '#f7d25d',
    sunset: '#df294c',
    cloud: '#d0d7df'
  },
  advancedSearchClearAllButton: {
    color: '#4A90E2'
  },
  advancedSearchFilterSelected: {
    backgroundColor: '#4A90E2'
  },
  advancedSearchFilterAddFilterButton: {
    color: '#4A90E2'
  },
  advancedSearchFilterListItem: {
    backgroundColor: '#4A90E2'
  },
  advancedSearchFilterListCategoryHeader: {
    color: 'black'
  },
  datePickerCurrent: {
    color: '#4A90E2'
  },
  datePickerDaySelected: {
    backgroundColor: '#4A90E2'
  },
  formControlInfoIcon: {
    color: '#4A90E2'
  },
  rafInput: {
    color: '#4A90E2'
  },
  mouseOverPopoverTypography: {
    color: '#0167DD'
  },
  noteDateDisplay: {
    color: '#828181'
  },
  segmentationCardTableCellFooter: {
    color: '#030303'
  },
  segmentationCardTableCellPrevious2Year: {
    color: '#D0D7DF'
  },
  segmentationCardTableCellPreviousYear: {
    color: '#2DA1FF'
  },
  segmentationCardTableCellYearCurrentYear: {
    color: '#283D5A'
  },
  snackBarButton: {
    color: '#2DA1FF'
  },
  snackBarAlertButton: {
    color: '#2DA1FF'
  },
  templateEditorContainer: {
    backgroundColor: '#96C12C'
  },
  templateEditorCode: {
    backgroundColor: '#F1F1F1'
  },
  templateEditorToolTipArrow: {
    color: '#96C12C'
  },
  templateEditorToolTipText: {
    background: '#96C12C',
    color: 'white'
  },
  templateEditorToolTipButton: {
    color: 'white'
  },
  templateEditMain: {
    backgroundColor: 'rgba(229, 231, 234, 0.6)'
  },
  templateGuideLinkItemHover: {
    color: '#96C12C'
  },
  tooltipContent: {
    color: 'white'
  },
  tooltipButton: {
    color: 'white'
  },
  flexFieldsClearButton: {
    color: '#4A90E2'
  },
  mrxCodesTableSuspectValue: {
    color: 'rgba(33,33,33,.4)'
  },
  suspectSourceTableYearCircle: {
    color: 'white'
  },
  suspectSourceTableCurrentYear: {
    color: '#8BC34E'
  },
  suspectSourceTablePreviousYear: {
    backgroundColor: '#F5A623'
  },
  suspectSourceTablePrevious2Year: {
    backgroundColor: '#4A90E2'
  },
  dxCodesTableBlueLabel: {
    backgroundColor: '#0167DD'
  },
  hccCodesTableSuspectValue: {
    color: 'rgba(33,33,33,.4)'
  },
  hccCodesTableTooltipContributorsTh: {
    color: 'white'
  },
  hccCodesTableTooltipContributorsTd: {
    color: 'white'
  },
  epiAppSwitchMenuSubheader: {
    backgroundColor: '#F1F3F3'
  },
  globalSearchResults: {
    backgroundColor: '#F5F5F5'
  },
  globalSearchError: {
    color: 'red'
  }
};
exports["default"] = _default;